<template>
    <el-dialog :visible.sync="isShow" title="续住" width="500px" append-to-body destroy-on-close :close-on-press-escape="false" :close-on-click-modal="false" @close="$emit('close')">
            
        <el-form ref="extendForm" :model="extendForm" label-width="100px" style="margin: 0 20px" size="small" :rules="rulesForm">
            <el-form-item label="订单号" prop="orderNo">
                <el-input type="text" v-model="extendForm.orderNo" disabled style="width: 250px"></el-input>
            </el-form-item>
            <el-form-item label="姓名" prop="customerName">
                <el-input type="text" v-model="extendForm.customerName" disabled style="width: 250px"></el-input>
            </el-form-item>
            <el-form-item label="电话号码" prop="customerMobile">
                <el-input type="text" v-model="extendForm.customerMobile" disabled style="width: 250px"></el-input>
            </el-form-item>
            <el-form-item label="身份证号码" prop="idNumber">
                <el-input type="text" v-model="extendForm.idNumber" disabled style="width: 250px"></el-input>
            </el-form-item>
            <el-form-item label="续住金额" prop="renewAmount">
                <el-input type="text" v-model="extendForm.renewAmount" placeholder="请输入续住金额" style="width: 160px;margin-right:10px;"></el-input>
                <span>已付款￥{{extendForm.orderLastPay }}元</span>
            </el-form-item>
            <el-form-item label="退房日期" prop="estimatedCheckOut">
                <el-date-picker v-model="extendForm.estimatedCheckOut" format="yyyy-MM-dd" value-format="yyyy-MM-dd" type="date" placeholder="选择日期" style="width: 250px"></el-date-picker>
            </el-form-item>

        </el-form>

        <div slot="footer" style="margin: 0 20px; text-align: right">
            <el-button type="text" size="small" @click="isShow = false">取消</el-button>
            <el-button type="primary" size="small" @click="handleSubmit('extendForm')">确认</el-button>
        </div>
    </el-dialog>
</template>


<script>
export default {
    props: {
        isExtend: {
            type: Boolean,
            default: false,
        },
        hotelId: {
            type: String,
            default: null,
        },
        roomId: {
            type: String,
            default: null,
        },
    },
    data() {
        const validatePrice = (rule, value, callback) => {
            if (value && !/^\d+(\.\d{1,2})?$/.test(value)) {
                callback(new Error("金额只能保留两位小数"));
            } else {
                callback();
            }
        };
        return {
            
            isShow: false,
            extendForm: {
                orderNo: "",
                customerName: "",
                idNumber: "",
                renewAmount: "",
                estimatedCheckOut: ""
            },
            rulesForm: {
                renewAmount: [{  validator: validatePrice, trigger: "blur" }],
                estimatedCheckOut: [{ required: true, message: "请选择续住日期", trigger: "blur" }],
            },
        }
    },
    watch: {
        isExtend(newVal) {
            this.isShow = !!newVal;
            if (!!newVal) {
                this.extendForm = {
                    hotelId: this.hotelId,
                    roomId: this.roomId,
                    orderNo: "",
                    customerName: "",
                    idNumber: "",
                    collection: "",
                    estimatedCheckOut: ""
                }

                this.getRoomOrderDetail();
            }
        },
    },
    methods: {
        handleSubmit(formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    this.submitLoading = true;

                    this.postRequest("/api/room/stayOver", {
                        estimatedCheckOut: this.extendForm.estimatedCheckOut,
                        renewAmount: this.extendForm.renewAmount,
                        roomId: this.extendForm.id,
                    })
                        .then((res) => {
                            this.submitLoading = false;
                            let data = res.data;
                            if (data.code == 200) {
                                this.$message.success(data.msg);
                                this.$emit('confirm')
                            }
                        })
                        .catch(() => {
                            this.submitLoading = false;
                        });
                }
            });
        },
        getRoomOrderDetail() {
            this.getRequest(`/api/roomOrder/getDetails?id=${this.roomId}`)
            .then(res => {
                let data = res.data;
                if(data.code == 200) {
                    data.data.idNumber = data.data.roomOrderGuestInfoVoList[0].idNumber;
                    data.data.customerName = data.data.roomOrderGuestInfoVoList[0].name;
                    data.data.customerMobile = data.data.roomOrderGuestInfoVoList[0].mobile;
                    data.data.renewAmount = "";
                    this.extendForm = data.data;
                    this.extendForm.estimatedCheckOut = "";
                }
            })
        }
    },
}
</script>